export default __webpack_public_path__ + "static/media/ownerrez_step1.b2c48f5e.jpg";